import { Pipe, PipeTransform } from '@angular/core';

export const customCurrencyTransform = (value: number, sign = '$'): string => {
  if (!value) value = 0;
  if (value !== Math.round(value)) {
    if (value < 0) return `-${sign}${(-value).toFixed(2)}`;
    return `${sign}${value.toFixed(2)}`;
  }
  if (value < 0) return `-${sign}${-value}`;
  return `${sign}${value}`;
};

@Pipe({
  name: 'customCurrency',
  standalone: true,
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(value: number, sign = '$'): string {
    return customCurrencyTransform(value, sign);
  }
}
